// ── App router by subdomain ─────────────────────────────────────────────────
// One bundle serves every hostname; which React tree mounts is decided here,
// once, at startup — before TenantProvider runs.
//
//   desarrollos.sivarsend.app  → <DesarrollosApp /> (standalone, NO TenantProvider —
//                                the expo/demo tenant handles its own tenant state)
//   everything else            → <TenantProvider><App /></TenantProvider>
//                                (sivarsend.app, www.sivarsend.app, maxi.*, latia.*,
//                                 localhost, and every future multi-tenant subdomain)
//
// The hostname check is EXACT match, never startsWith/includes — a substring
// match would hijack hostnames like `desarrollos-staging.sivarsend.app` or
// anything else merely containing "desarrollos".
//
// Local testing: in non-production builds only, `?app=desarrollos` forces the
// standalone tree (e.g. http://localhost:3000?app=desarrollos). The query-param
// escape hatch is compiled out of behavior in production so it can never be used
// to reach a standalone app from a customer-facing hostname.
//
// Adding a future standalone tenant app (SeleSend, TriSend, …):
//   1. Build it under src/<tenant>/<Tenant>App.jsx, fully self-contained.
//   2. Import it below.
//   3. Add one entry to STANDALONE_APPS: 'selesend.sivarsend.app': SeleSendApp
//      (and its dev slug in DEV_APP_SLUGS, e.g. selesend: SeleSendApp).
//   4. Point the DNS/host at this same build. Nothing in src/App.js,
//      src/context/TenantContext.js, or the main tree needs to change.
import './styles/theme.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DesarrollosApp from './desarrollos/DesarrollosApp';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { TenantProvider } from './context/TenantContext';

// hostname (exact) → standalone app component
const STANDALONE_APPS = {
  'desarrollos.sivarsend.app': DesarrollosApp,
};

// ?app=<slug> → standalone app component (development builds only)
const DEV_APP_SLUGS = {
  desarrollos: DesarrollosApp,
};

const resolveStandaloneApp = () => {
  const byHostname = STANDALONE_APPS[window.location.hostname];
  if (byHostname) return byHostname;

  if (process.env.NODE_ENV !== 'production') {
    const slug = new URLSearchParams(window.location.search).get('app');
    if (slug && DEV_APP_SLUGS[slug]) return DEV_APP_SLUGS[slug];
  }

  return null;
};

const StandaloneApp = resolveStandaloneApp();

if (process.env.NODE_ENV !== 'production') {
  console.log(
    `[router] ${window.location.hostname} → ${StandaloneApp ? StandaloneApp.name : 'TenantProvider + App'}`
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {StandaloneApp ? (
      <StandaloneApp />
    ) : (
      <TenantProvider>
        <App />
      </TenantProvider>
    )}
  </React.StrictMode>
);

// Register the service worker for PWA offline support.
// Only activates in production builds (npm run build).
// In development (npm start), this is a no-op.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('[SW] App update available. Applying immediately...');
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
  onSuccess: () => {
    console.log('[SW] Comando Ops is ready for offline use.');
  },
});
